// Anonymous voice-intake draft — the bridge between "talk first" and "sign in
// to get matched" on the v2 landing (GlonetAiLandingV2).
//
// A visitor talks to the intake agent BEFORE having an account; whatever the
// agent saves lands here (localStorage) instead of the API. After sign-in —
// including the full-page Google OAuth redirect, which wipes React state —
// the landing finds the draft and writes it through the normal authenticated
// register/update path, then clears it. Drafts expire after an hour: stale
// answers should not silently become someone's profile days later.
const DRAFT_KEY = "ga_voice_draft";
const DRAFT_TTL_MS = 60 * 60 * 1000; // 1 hour

export function readVoiceDraft() {
  try {
    const raw = JSON.parse(localStorage.getItem(DRAFT_KEY) || "null");
    if (!raw || typeof raw !== "object") return null;
    if (!raw.ts || Date.now() - raw.ts > DRAFT_TTL_MS) {
      localStorage.removeItem(DRAFT_KEY);
      return null;
    }
    const objective = (raw.objective || "").trim();
    const offering = (raw.offering || "").trim();
    if (!objective && !offering) return null;
    return { objective, offering, ts: raw.ts };
  } catch (e) {
    return null;
  }
}

export function writeVoiceDraft({ objective, offering }) {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify({
      objective: (objective || "").trim(),
      offering: (offering || "").trim(),
      ts: Date.now(),
    }));
  } catch (e) { /* storage off — the session still worked, it just won't survive sign-in */ }
}

export function clearVoiceDraft() {
  try { localStorage.removeItem(DRAFT_KEY); } catch (e) { /* storage off */ }
}
